'use client';

/**
 * useLocale.ts — språkvalg («no» | «en») for offentlige sider
 *
 * Serveren rendrer DEFAULT_LOCALE; klienten oppdateres etter hydrering
 * (useSyncExternalStore), uten hydreringsfeil. Setter også <html lang>.
 */

import { useEffect, useSyncExternalStore } from 'react';
import { DEFAULT_LOCALE, readLocale, setLocale, subscribeLocale } from '@/lib/locale';
import type { Locale } from '@/types/landing';

export function useLocale() {
  const locale = useSyncExternalStore<Locale>(subscribeLocale, readLocale, () => DEFAULT_LOCALE);

  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  return { locale, setLocale };
}
